"use client";

import { themeBootScript } from "@/lib/theme";

/**
 * Error boundary de DERNIER recours (crash du layout racine lui-même).
 * Remplace tout le document → on ré-injecte le themeBootScript pour que
 * la classe `.dark` soit appliquée et que l'écran d'erreur respecte le
 * thème (dark/light) au lieu d'être systématiquement en clair.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="fr">
      <head>
        <script dangerouslySetInnerHTML={{ __html: themeBootScript }} />
        <style>{`
          body{margin:0;font-family:system-ui,-apple-system,sans-serif;min-height:100dvh;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:.75rem;padding:1.5rem;text-align:center;background:#fbf8f0;color:#1f2937}
          html.dark body{background:#171717;color:#e5e5e5}
          button{margin-top:.5rem;padding:.6rem 1.2rem;border-radius:9999px;border:none;background:#2D6A4F;color:#fff;font-size:.9rem;font-weight:600;cursor:pointer}
          p{margin:0}
        `}</style>
      </head>
      <body>
        <p style={{ fontSize: "1.1rem", fontWeight: 600 }}>Une erreur est survenue</p>
        <p style={{ fontSize: ".85rem", opacity: 0.8, maxWidth: "22rem" }}>
          {error?.message || "Quelque chose s'est mal passé."}
        </p>
        <button type="button" onClick={() => reset()}>Réessayer</button>
      </body>
    </html>
  );
}
